<template>
  <div>
    <ejs-dropdownbutton
      :items="items"
      css-class="e-caret-hide grid-action p-0"
      :select="onSelect"
      :open="onOpen"
    >
      <font-awesome-icon
        :icon="['fas', 'ellipsis-v']"
        size="sm"
      />
    </ejs-dropdownbutton>
  </div>
</template>

<script>
import { iframeParentCommunication } from '../../mixins/iframeParentCommunication'
import { mapState } from 'vuex'

export default {
  mixins: [iframeParentCommunication],
  data () {
    return {
      items: [
        { text: 'Details', id: 'details' },
        { text: 'Edit', id: 'edit' },
        { text: 'Clone', id: 'clone' }
      ],
      data: {
        projectId: 0
      }
    }
  },
  computed: {
    ...mapState({
      clientId: state => state.manageCampaigns.clientId,
      companyId: state => state.manageCampaigns.companyId
    })
  },
  methods: {
    onSelect (args) {
      let uri = ''
      if (args.item.text === 'Details' && this.data.projectId) {
        const urlParams = new URLSearchParams(window.location.search)
        const userEmailURL = urlParams.get('userEmail')
        this.$router.push({ name: 'CampaignDetailsSummary', query: { clientId: this.clientId, companyId: this.companyId, campaignId: this.data.projectId, userEmail: userEmailURL } }, () => {})
      } else if (args.item.text === 'Edit') {
        if (this.data.statusCampaignTranslated === 'Scheduled Active' || this.data.statusCampaignTranslated === 'Scheduled Inactive') {
          this.$parent.$parent.openDialog()
        } else {
          const uri = '/Project.mvc/Project/Edit?projectId=' + this.data.projectId + '#template'
          const data = { action: 'eIn_redirect', value: uri }
          this.SendMessageToParent(data)
        }
      } else if (args.item.text === 'Clone') {
        const data = { action: 'eIn_clone_campaign', value: this.data.projectId }
        this.SendMessageToParent(data)
      } else {
        uri = '/Project.mvc/Project/ManageCampaigns'
        const data = { action: 'eIn_redirect', value: uri }
        this.SendMessageToParent(data)
      }
    },
    onOpen (args) {
      args.element.parentElement.style.marginLeft = '-20px'
      this.$store.commit('SET_GRIDSELECTEDCAMPAIGNS', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
